import http from "../utils/http-common";

const baseHistoryPath = "api/tank-history";

export const getOptionsFilter = (query: string) => {
  return http.get(`${baseHistoryPath}/options/filter-tank-logs?${query}`);
};

export const getHistory = (query: string) => {
  return http.get(`${baseHistoryPath}?${query}`);
};
